<template>
	<div class="col-lg-12">
		<span style="cursor: pointer" class="float-left" @click="more"
			><i class="fas fa-plus-circle fa-2x" data-toggle="tooltip" title="Add more"></i
		></span>
		<span style="cursor: pointer; float: right" @click="refresh"
			><i class="fas fa-sync-alt fa-2x" data-toggle="tooltip" title="Reset"></i
		></span>
		<span
			style="cursor: pointer; float: right"
			@click="hideNotLinked = !hideNotLinked"
			data-toggle="tooltip"
			title="Hide/show nodes without links"
			><i :class="hideNotLinked ? 'fa fa-eye-slash fa-2x' : 'fa fa-eye fa-2x'"></i
		></span>

		<a @click="downloadPNG" download="detect_network.png">
			<span style="cursor: pointer; float: right">
				<i class="fas fa-download fa-2x" data-toggle="tooltip" title="Download PNG"></i>
			</span>
		</a>

		<span
			class="zoom-to-fit"
			style="cursor: pointer; float: right"
			@click="zoomToFit"
			data-toggle="tooltip"
			title="Fit graph to screen"
		>
		</span>

		<div id="graph"></div>
		<!-- <div v-else>
			<p>no data to display</p>
		</div> -->
	</div>
</template>
<script>
import ForceGraph from "force-graph";
import * as d3 from "d3";

export default {
	name: "NetworkChart",
	props: {
		axios: {
			type: String,
			default: "",
		},
		title: {
			type: String,
			default: null,
		},
		clickable: {
			default: true,
		},
		anydate: {
			default: false,
		},
		compare: {
			default: false,
		},
		type: {
			type: String,
			default: "category",
		},
		firstgraph: {
			default: false,
		},
		panel: {
			type: String,
			default: "",
		},
		segment: {
			type: String,
			default: "",
		},
		date: {
			lte: "",
			gte: "",
		},
		country: {
			type: String,
			default: "",
		},
		category: {
			type: String,
			default: "",
		},
		subcategory: {
			type: String,
			default: "",
		},
	},
	watch: {
		panel(newVal) {
			this.parameters.panel = newVal;
			this.refresh();
		},
		segment(newVal) {
			this.parameters.segment = newVal;
			this.refresh();
		},
		date: {
			deep: true,
			handler(newVal) {
				this.parameters.date = newVal;
			},
		},
		country(newVal) {
			if (newVal == "") {
				delete this.parameters.country;
			} else {
				this.parameters.country = newVal;
			}
			this.refresh();
		},
		category() {
			this.clickCat();
		},
		subcategory() {
			this.clickSubCat();
		},
		hideNotLinked() {
			this.setNodeVisibility();
		},
	},
	data() {
		return {
			data: {},
			gData: {
				nodes: [],
				links: [],
			},
			clickednode: undefined,
			Graph: {},
			graphWidth: 0,
			graphHeight: 0,
			graphType: "category",
			parameters: {},
			hideNotLinked: false,
			docCounts: [],
			maxSizeNode: 100,
		};
	},
	methods: {
		clickCat() {
			let node = {
				type: "category",
				name: this.category,
				labelVal: this.category,
			};
			// this.refresh();
			setTimeout(() => {
				this.clicked(node);
			}, 1000);
		},
		clickSubCat() {
			let node = {
				type: "subcategory",
				name: this.subcategory,
				labelVal: this.subcategory,
			};

			this.clicked(node);
		},
		loadComponent() {
			this.graphType = this.parameters.type = this.type;
			this.getData("network", { data: this.parameters });
		},
		refresh() {
			this.graphType = this.parameters.type = this.type;
			this.gData = {
				nodes: [],
				links: [],
			};
			this.data = {};
			this.clickednode = undefined;
			this.getData("network", { data: this.parameters });
			if (this.category !== "") {
				setTimeout(() => {
					this.clickCat();
				}, 1000);
			}
			if (this.subcategory !== "") {
				setTimeout(() => {
					this.clickSubCat();
				}, 1000);
			}
		},
		async more() {
			let clicked = this.gData.nodes
				.filter((element) => {
					return element.clicked == true;
				})
				.pop();
			let add = "subcategory";
			if (clicked) {
				if (clicked.type == "subcategory") {
					add = "mastertag";
				} else if (clicked.type == "mastertag") {
					add = "mastertag1";
				}
				await this.linkParentChildren(clicked, true);
				let begin = this.gData.nodes.filter((element) => element.type == add).length;

				await this.formatData(this.data.slice(begin, begin + 5));
				await this.Graph.graphData(this.gData);

				this.Graph.d3Force("center", d3.forceCenter(this.graphWidth / 100, this.graphHeight / 100));
			}

			/// will be back after case coorection
			// the idea is to find the final clicked child node
			// and to apend new nodes to it
		},
		treatResponse(response) {
			this.data = response.data;
			this.docCounts = [];
			//console.log(this.data);
			if (this.data.length === 0) {
				this.gData = {
					nodes: [],
					links: [],
				};
			} else {
				this.formatData(this.data);

				this.graphWidth = document.querySelector("#graph").clientWidth;
				this.graphHeight = document.querySelector("#graph").clientHeight;
				//console.log(document.querySelector("#graph"));
				//console.log(document.querySelector("#graph").clientHeight);
				this.graphHeight = this.graphHeight > 800 ? 800 : this.graphHeight;
				this.graphHeight = this.graphHeight < 600 ? 600 : this.graphHeight;
			}
			this.draw();
		},
		formatData(data) {
			for (let i = 0; i < data.length; i++) {
				this.docCounts[data[i].key] = data[i].doc_count;
			}
			let maxCount = Math.max.apply(null, Object.values(this.docCounts));
			let base_length = this.gData.nodes.length;

			for (let i = 0; i < data.length; i++) {
				if (this.gData.nodes.find((element) => element.labelVal == data[i].key) != undefined) continue;
				this.gData.nodes.push({
					id: base_length + i,
					name: data[i].key,
					val: (data[i].doc_count * this.maxSizeNode) / maxCount,
					labelVal: data[i].key,
					type:
						this.clickednode && this.clickednode.type == "category"
							? "subcategory"
							: this.clickednode && this.clickednode.type == "subcategory"
							? "mastertag"
							: this.clickednode && this.clickednode.type == "mastertag"
							? "mastertag1"
							: this.clickednode && this.clickednode.type == "mastertag1"
							? "mastertag1"
							: "category",
					color:
						this.clickednode && this.clickednode.type == "category"
							? "rgba(51, 209, 205, 0.7)"
							: this.clickednode && this.clickednode.type == "subcategory"
							? "rgba(35, 5, 107, 0.7)"
							: this.clickednode && this.clickednode.type == "mastertag"
							? "rgba(35, 5, 107, 0.7)"
							: this.clickednode && this.clickednode.type == "mastertag1"
							? "rgba(35, 5, 107, 0.7)"
							: "rgba(239, 64, 46, 0.7)",
					clicked: false,
				});

				if (this.clickednode != undefined && Object.keys(this.clickednode).length > 0 && this.clickednode.type != "mastertag") {
					this.gData.links.push({
						source: this.clickednode.id,
						target: base_length + i,
					});
					if (data[i].hits != undefined && data[i].hits.buckets.length > 0) {
						for (let j = 0; j < data[i].hits.buckets.length; j++) {
							this.gData.links.push({
								source: this.gData.nodes.find((element) => element.labelVal == data[i].hits.buckets[j].key).id,
								target: base_length + i,
							});
						}
					}
				}
				if (this.clickednode != undefined && this.clickednode.type == "mastertag") {
					this.gData.links.push({
						source: this.clickednode.id,
						target: this.gData.nodes.find((element) => element.labelVal == data[i].key).id,
					});
					for (let k = 0; k < data[i].top_hits.hits.hits.length; k++) {
						for (let j = 0; j < data[i].top_hits.hits.hits[k]._source.mastertags.length; j++) {
							for (let q = 0; q < data[i].top_hits.hits.hits[k]._source.mastertags[j].archi.length; q++) {
								let search = this.gData.links.find((element) => {
									if (data[i].top_hits.hits.hits[k]._source.mastertags[j].archi[q].cat != undefined) {
										return (
											element.target ==
											this.gData.nodes.find(
												(element) =>
													element.labelVal == data[i].top_hits.hits.hits[k]._source.mastertags[j].archi[q].cat
											).id
										);
									} else {
										return false;
									}
								});
								if (search == undefined || search.length < 1) {
									this.gData.links.push({
										source: this.clickednode.id,
										target: this.gData.nodes.find(
											(element) =>
												element.labelVal == data[i].top_hits.hits.hits[k]._source.mastertags[j].archi[q].cat
										).id,
									});
								}
							}
						}
					}
				}
			}

			this.data = {};
		},
		removeData(node) {
			let nodesToremove = [];
			if (node.type == "category") {
				nodesToremove = this.gData.links.filter((obj) => obj.source.id == node.id);

				nodesToremove = nodesToremove.map((x) => x.target);
				let index = this.gData.nodes.filter((element) => element.clicked == true);

				if (index.length == 1) {
					this.gData.links = [];
				}
			} else if (node.type == "subcategory") {
				nodesToremove = this.gData.links.filter((obj) => obj.source.id == node.id);
				nodesToremove = nodesToremove.map((x) => x.target);
			} else if (node.type == "mastertag") {
				nodesToremove = this.gData.links.filter((obj) => obj.source.id == node.id && obj.source.type == "mastertag1");
				nodesToremove = nodesToremove.map((x) => x.target);
			} else if (node.type == "mastertag1") {
				nodesToremove = this.gData.links.filter((obj) => obj.source.id == node.id && obj.source.type == "mastertag1");
			}

			this.gData.links = this.gData.links.filter((obj) => {
				return obj.source.id != node.id;
			});
			this.gData.nodes = this.gData.nodes.filter((obj) => {
				return !nodesToremove.includes(obj);
			});

			this.gData.links = this.gData.links.filter((obj) => {
				return !nodesToremove.includes(obj.target);
			});
			this.gData.links = this.gData.links.filter((obj) => {
				return this.gData.nodes.find((element) => element == obj.target || element == obj.source) != undefined;
			});
			this.removeOrphans();
			node.clicked = false;
		},
		removeOrphans() {
			let nodesToremove = [];
			for (let index = 0; index < this.gData.nodes.length; index++) {
				let find = this.gData.links.find(
					(obj) => this.gData.nodes[index].id == obj.source.id || this.gData.nodes[index].id == obj.target.id
				);
				if (find == undefined && this.gData.nodes[index].type != "category") {
					nodesToremove.push(this.gData.nodes[index]);
				} else if (find != undefined && this.gData.nodes[index].type != "category") {
					let father = this.gData.nodes.find((element) => element.id == find.source.id);
					if (father == undefined) {
						nodesToremove.push(this.gData.nodes[index]);
					}
				}
			}
			this.gData.nodes = this.gData.nodes.filter((obj) => {
				return !nodesToremove.includes(obj);
			});
			this.gData.links = this.gData.links.filter((obj) => {
				return !nodesToremove.includes(obj.target);
			});
		},
		async linkParentChildren(node, after = undefined) {
			let index = this.gData.nodes.findIndex((element) => element.labelVal == node.labelVal);
			if (this.gData.nodes[index] == undefined) {
				this.$emit("nodata", true);
				return this.data;
			}
			this.gData.nodes[index].clicked = true;
			this.gData.nodes[index].color = "rgba(254, 207, 137, 0.7)";
			this.clickednode = this.gData.nodes[index];
			let childs = "";

			if (node.type == "category") {
				childs = "subcategory";
			} else if (node.type == "subcategory") {
				childs = "mastertag";
			} else if (node.type == "mastertag") {
				childs = "mastertag1";
			}
			let localParams = this.parameters;
			localParams.type = childs;
			let filters = {
				data: { node: node.labelVal, type: childs, ...localParams },
			};
			if (after) {
				filters = {
					data: {
						node: node.labelVal,
						type: childs,
						after: after,
						...localParams,
					},
				};
			}
			const res = await this.$axios.get(this.$backendUrl + "network", {
				params: filters,
				paramsSerializer: (params) => {
					return this.$Qs.stringify(params, { arrayFormat: "brackets" });
				},
			});
			this.data = res.data;
		},
		async clicked(node) {
			await this.linkParentChildren(node);
			await this.formatData(this.data);
			await this.Graph.graphData(this.gData);
			//this.Graph.d3Force("center", d3.forceCenter(this.graphWidth / 100, this.graphHeight / 100));
			this.setNodeVisibility();
			this.Graph.centerAt(node.x, node.y, 1500);
			this.clickednode = undefined;
		},
		async unclick(node) {
			if (node.type == "category") {
				node.color = "rgba(239, 64, 46, 0.7)";
			} else if (node.type == "subcategory") {
				node.color = "rgba(51, 209, 205, 0.7)";
			} else {
				node.color = "rgba(35, 5, 107, 0.7)";
			}
			await this.removeData(node);
			await this.Graph.graphData(this.gData);
			this.Graph.d3VelocityDecay(0.1);
			//this.Graph.d3Force("center", d3.forceCenter(this.graphWidth / 100, this.graphHeight / 100));

			this.Graph.d3Force("collide", d3.forceCollide(13));

			this.setNodeVisibility();
			//this.Graph.centerAt(node.x, node.y, 1500);
			this.Graph.autoPauseRedraw(false);
			this.data = {};
		},
		labelingLink(link1, link2, ctx) {
			const MAX_FONT_SIZE = 4;
			const LABEL_NODE_MARGIN = this.Graph.nodeRelSize() * 1.5;

			const start = link1.source;
			const end = link1.target;

			// ignore unbound links
			if (typeof start !== "object" || typeof end !== "object") return;

			// calculate label positioning
			const textPos = Object.assign(
				...["x", "y"].map((c) => ({
					[c]: start[c] + (end[c] - start[c]) / 2, // calc middle point
				}))
			);

			const relLink = { x: end.x - start.x, y: end.y - start.y };

			const maxTextLength = Math.sqrt(Math.pow(relLink.x, 2) + Math.pow(relLink.y, 2)) - LABEL_NODE_MARGIN * 2;

			let textAngle = Math.atan2(relLink.y, relLink.x);
			// maintain label vertical orientation for legibility
			if (textAngle > Math.PI / 2) textAngle = -(Math.PI - textAngle);
			if (textAngle < -Math.PI / 2) textAngle = -(-Math.PI - textAngle);

			const label = link2.label;
			// estimate fontSize to fit in link length
			ctx.font = "5px Sans-Serif";
			const fontSize = Math.min(MAX_FONT_SIZE, maxTextLength / ctx.measureText(label).width);
			ctx.font = `${fontSize}px Sans-Serif`;
			const textWidth = ctx.measureText(label).width;
			const bckgDimensions = [textWidth, fontSize].map((n) => n + fontSize * 0.2); // some padding

			// draw text label (with background rect)
			ctx.save();
			ctx.translate(textPos.x, textPos.y);
			ctx.rotate(textAngle);

			ctx.fillStyle = "rgba(255, 255, 255, 0.8)";
			ctx.fillRect(-bckgDimensions[0] / 2, -bckgDimensions[1] / 2, ...bckgDimensions);

			ctx.textAlign = "center";
			ctx.textBaseline = "middle";
			ctx.fillStyle = "darkgrey";
			ctx.fillText(label, 0, 0);
			ctx.restore();
		},
		clickLink(link) {
			if (link != null) {
				link.label = link.source.name + ">" + link.target.name;
				this.$axios
					.get(this.$backendUrl + "countMastertags", {
						params: {
							data: {
								source: {
									type: link.source.type,
									label: link.source.name,
								},
								target: {
									type: link.target.type,
									label: link.target.name,
								},
							},
						},
						paramsSerializer: (params) => {
							return this.$Qs.stringify(params, {
								arrayFormat: "brackets",
							});
						},
					})
					.then((response) => {
						link.label = response.data.count + " mastertags associés";
						this.Graph.linkLabel("label");
						this.Graph.linkCanvasObjectMode(() => "after");
						this.Graph.linkCanvasObject((links, ctx) => {
							if (link == links) {
								this.labelingLink(links, link, ctx);
							}
						});
					});
			}
		},
		async nodeHover(node /*, prevNode*/) {
			if (node && this.parameters.date != undefined) {
				let level = node.type == "category" ? "categories" : node.type == "subcategory" ? "subcategories" : "mastertag";
				const res = await this.$axios.get(this.$backendUrl + "topsFlops", {
					params: {
						name: node.labelVal,
						level: level,
						filters: this.parameters,
					},
					paramsSerializer: (params) => {
						return this.$Qs.stringify(params, {
							arrayFormat: "brackets",
						});
					},
				});

				return res.data.evolution;
			} else {
				return [];
			}
		},
		draw() {
			this.Graph = ForceGraph()(document.getElementById("graph"))
				.graphData(this.gData)
				.width(this.graphWidth)
				.height(this.graphHeight)
				.d3Force("center", null)
				.nodeCanvasObjectMode(() => "after")
				.nodeCanvasObject((node, ctx /*, globalScale*/) => {
					const label = node.name;
					const fontSize = 10;
					ctx.font = `${fontSize}px Sans-Serif`;
					ctx.textAlign = "center";
					ctx.textBaseline = "middle";
					ctx.fillStyle = "black";
					ctx.fillText(label, node.x, node.y + 20);
				})
				.onNodeClick((node /*, event*/) => {
					//this.Graph.zoom(1, 2000);

					if (node.clicked == undefined || node.clicked == false) {
						this.clicked(node);
					} else {
						this.unclick(node);
					}
				})
				.onLinkClick((link) => {
					this.clickLink(link);
				})
				.onNodeHover((node, prevNode) => {
					if (node && !node.name.includes("%") && prevNode == undefined) {
						let evolution = this.nodeHover(node, prevNode);
						evolution.then((data) => {
							if (Object.keys(data).length > 0) {
								node.name += " " + (data[node.labelVal].posts >= 0 ? "+" : "") + data[node.labelVal].posts + "%";
							}
						});
					} else if (prevNode && node == undefined) {
						prevNode.name = prevNode.labelVal;
					}
				});

			this.Graph.d3Force("link")
				.distance((link) => (link.distance = 300))
				.strength(0.25);

			this.Graph.cooldownTime(1)
				.warmupTicks(150)
				.onEngineStop(() => {
					const nodes = this.gData.nodes;
					if (nodes) {
						nodes.forEach((/*node, index*/) => {
							/*if (index !== nodes.length - 1) {
								//node.fx = node.x;
								//node.fy = node.y;
							}*/
							this.Graph.d3ReheatSimulation();
						});
					}
				});

			/*this.Graph.d3Force("collide", d3.forceCollide(this.Graph.nodeRelSize())).d3Force("box", () => {
				const minDistance = this.maxSizeNode * this.Graph.nodeRelSize();
				console.log(minDistance);

				const nodes = this.gData.nodes;
				nodes.forEach((node) => {
					const x = node.x || 0,
						y = node.y || 0;

					// bounce on box walls
					if (Math.abs(x) > minDistance) {
						node.vx *= -1;
					}
					if (Math.abs(y) > minDistance) {
						node.vy *= -1;
					}
				});
			});*/

			this.Graph.cooldownTicks(100);
			this.Graph.d3Force("charge").distanceMax(200);
			this.Graph.d3Force("charge").strength(-200);
		},
		getLinkedNodes() {
			let linkedNodes = [];
			for (let i = 0; i < this.gData.links.length; i++) {
				if (typeof this.gData.links[i].source === "object") {
					linkedNodes.push(this.gData.links[i].source.id);
					linkedNodes.push(this.gData.links[i].target.id);
				} else {
					linkedNodes.push(this.gData.links[i].source);
					linkedNodes.push(this.gData.links[i].target);
				}
			}
			return linkedNodes;
		},
		setNodeVisibility() {
			if (this.hideNotLinked) {
				let linkedNodes = this.getLinkedNodes();
				this.Graph.nodeVisibility((node) => {
					return linkedNodes.indexOf(node.id) !== -1;
				});
			} else {
				this.Graph.nodeVisibility((/*node*/) => {
					return true;
				});
			}
		},
		downloadPNG() {
			let canvas = document.getElementsByTagName("canvas")[0];

			let image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
			let link = document.createElement("a");
			document.body.appendChild(link); // for Firefox
			link.setAttribute("href", image);
			link.setAttribute("download", "detect_network.png");
			link.click();

			/*let scale = 4;
			let newCanvas = document.createElement("canvas");
			newCanvas.setAttribute("width", this.graphWidth * scale);
			newCanvas.setAttribute("height", this.graphHeight * scale);
			let ctx = newCanvas.getContext("2d");
			ctx.imageSmoothingQuality = "high";
			ctx.drawImage(canvas, 0, 0, this.graphWidth, this.graphHeight, 0, 0, this.graphWidth * scale, this.graphHeight * scale);

			image = newCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
			link = document.createElement("a");
			document.body.appendChild(link); // for Firefox
			link.setAttribute("href", image);
			link.setAttribute("download", "detect_network2.png");
			link.click();
			*/

			//image = canvas.toDataURL("image/png");
			//let svg_img = document.createElementNS("http://www.w3.org/2000/svg", "svg");
			//svg_img.setAttributeNS("http://www.w3.org/1999/download", "download", "detect_network.svg");
			//svg_img.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", image);

			// let svgAsXML = new XMLSerializer().serializeToString(svg_img);
			// let url = "data:image/svg+xml," + encodeURIComponent(svgAsXML);

			// let linkSvg = document.createElement("a");
			// document.body.appendChild(linkSvg); // for Firefox
			// console.log(svg_img);
			// linkSvg.setAttribute("href", svg_img);
			// linkSvg.setAttribute("download", "detect_network.svg");
			// linkSvg.click();
		},
		zoomToFit() {
			let linkedNodes = this.getLinkedNodes();
			let nodeFilter = function callbackFn(node) {
				return linkedNodes.indexOf(node.id) !== -1;
			};
			this.Graph.zoomToFit(400, 25, nodeFilter);
		},
	},
};
</script>

<style scoped>
#graph {
	min-height: 600px;
	height: auto;
}
.highcharts-container {
	overflow: visible !important;
}
.fa-2x {
	margin-left: 5px;
	margin-right: 5px;
}
.fa-eye,
.fa-eye-slash {
	font-size: 28px;
}

.zoom-to-fit {
	height: 35px;
	width: 35px;
	margin-left: 5px;
	margin-right: 5px;
	margin-top: -4px;
	background: url("/img/zoom-to-fit.svg");
	background-size: cover;
}
</style>
